<template>
  <div class="input-wrapper">
    <label :for="id" v-if="labelTop && label"  :class="{'label-small': (inFocus ||(value && value.length > 0))}">{{label}}</label>
    <the-mask v-if="type === 'tel'" type="tel" :masked="false"
              :mask="['+7 (###) ###-##-##']" v-model="stateValue"
              :id="id" :name="name"
              :class="classList"
              :v-bind="value"
              :placeholder="placeholder"/>

    <input v-else :type="type" :name="name" :id="id" v-model="stateValue"
           :placeholder="placeholder"
           @blur="onFocus($event)"
           @focusout="onFocusOut($event)"
           :class="classList"
           :v-bind="value"
           :maxlength="maxLength"/>

    <label :for="id" v-if="!labelTop && label"  :class="{active: value && value.length > 0}">{{label}}</label>
  </div>
</template>

<script>
  import { TheMask } from 'vue-the-mask'

  export default {
    props: {
      type: { default: 'text', },
      label: String,
      name: String,
      placeholder: String,
      light: { type: Boolean, default: false, },
      id: String,
      value: String,
      maxLength: { default: 255, },
      valid: { type: Function },
      invalid: { type: Function },
      labelTop: { type: Boolean, default: false, },
      noTextNormal: { type: Boolean, default: false, },
    },
    data() {
      return {
        stateValue: '',
        inFocus: false,
      };
    },
    computed: {
      classList() {
        return [{ 'has-label': this.label, 'theme-light': this.light, 'theme-normal': !this.light && !this.noTextNormal}];
      },
    },
    methods: {
      validate() {
        if(this.type === 'tel') {
          if(this.stateValue && this.stateValue.length === 10) {
            this.$emit('valid');
          } else {
            this.$emit('invalid');
          }
        } else {
          if(this.stateValue && this.stateValue.length > 0) {
            this.$emit('valid');
          } else {
            this.$emit('invalid');
          }
        }
      },
      onFocus (event) {
          this.inFocus = true;
      },
      onFocusOut (event) {
        this.inFocus = false;
      },
    },
    mounted() {
      this.stateValue = this.value;
    },
    watch: {
      stateValue(value) {
        this.$emit('input', value);
        this.validate();
      }
    },
    components: { TheMask },
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/typography.scss";

  @mixin activeLabel() {
    opacity: 0;
  }

  .input-wrapper {
    position: relative;
    display: block;
    // overflow: hidden;
    margin: 0 5px 5px 0;
    label {
      position: absolute;
      font-size: $font-size-p;
      color: $color-input-placeholder;
      left: 15px;
      top: 50%;
      //transform: translateY(-50%);
      transform-origin: left center;
     // text-transform: uppercase;
      font-weight: bold;
      pointer-events: none;
      @include ease();
      &.active {
        @include activeLabel;
      }
    }
    input {
      height: 50px;
      line-height: 50px;
      font-size: $font-size-p;
      color: $color-input-text;
      padding: 0 15px;
      border: none;
      display: block;
      width: 100%;
      box-sizing: border-box;
      outline: none !important;
      &.theme-light {
        background: $color-white;
      }
      &.theme-normal {
        background: $color-blue-6;
        @include ease(background);
        &:focus {
          outline: 2px solid $color-text !important;
          background: $color-white;
        }
      }

      @include placeholder {
        line-height: 50px;
        color: $color-input-placeholder;
        font-size: $font-size-p;
        text-transform: uppercase;
        transition: color 0.2s ease-in-out;
      }
      &.has-label {
        @include placeholder {
          color: transparent;
        }
      }
      &:focus {
        & + label {
          @include activeLabel; 
        }
        @include placeholder {
          color: $color-input-text;
        }
      }

      @media(max-width: $media_xs) {
        height: 40px;
        font-size: 14px;
      }
    }
  }
   .input-container input-text > label {
    
   }
.input-container input-text > label {
  top: 18%;
line-height: 24px;
  color: #8C8D90;
position: absolute;
left: 16px;
bottom: 16px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;


transition: all 0.5s linear;
}
/*.input-container input-text > label.label-small {
  padding-bottom: 38px;
font-weight: 500;
font-size: 13px;
line-height: 20px;
color: #8C8D90;
bottom: 30px;
}*/
 .input-container input-text > input {
        padding-top: 22px;
        padding-left: 10px;
        font-weight: 500;
        border: none;
        outline: none;
        width: 100%;
        font-weight: 500;
font-size: 15px;
line-height: 24px;
color: #3F435F;
   input:-webkit-autofill,
   input:-webkit-autofill:hover,
   input:-webkit-autofill:focus,
   input:-webkit-autofill:active {
     -webkit-box-shadow: 0 0 0px 10em white inset !important;
     -webkit-text-fill-color: white !important;
   }



  }

  .border-error input-text {
    border-bottom: 1px solid #ff0000 !important;
  }
  .contacts-form .input-wrapper label {
    left: 7px;
    top: 21%;
    font-size: 15px;
    padding-left: 2px;
    padding-right: 2px;
  }
</style>



// WEBPACK FOOTER //
// components/shared/_any/InputText.vue